class ScrollToAnchor extends window.BAO.CustomElement() {
  setupListeners() {
    super.setupListeners();
    this.scrollToEl();
  }

  scrollToEl() {
    const links = document.querySelectorAll('scroll-to-anchor');

    links.forEach(link => {
      link.addEventListener('click', function(event) {
        event.preventDefault();
        const targetId = this.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        const siteHeader = document.querySelector('sticky-site-header');
        const headerHeight = siteHeader ? siteHeader.offsetHeight : 0;

        const targetPosition = targetElement.offsetTop - headerHeight - 50;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      });
    });
  }
}

customElements.define('scroll-to-anchor', ScrollToAnchor);
